import { render } from "./Online.vue?vue&type=template&id=167e0f55&scoped=true"
import script from "./Online.vue?vue&type=script&lang=js"
export * from "./Online.vue?vue&type=script&lang=js"

import "./Online.vue?vue&type=style&index=0&id=167e0f55&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167e0f55"]])

export default __exports__